export default __webpack_public_path__ + "static/media/nature_black_male.3728d113.png";